<template>
    <div class="NoteWrite note_view_wrap">
        <KvTable :items="items"></KvTable>
    </div>

</template>
<script>
    import KvTable from '@/components/Table/kvTable/index'

    export default {
        name: `NoteWrite`,
        props: ['notes', 'selectedIdx', 'seqMedicalRelation'],
        components: {KvTable},
        data() {
            const item = [
                {
                    index: 0,
                    keyTitle: this.$t('title'),
                    keyType: 'DefaultInput',
                    class: [],
                    keyRange: [],
                    values: '',
                    maxLength: 60,
                }, {
                    index: 1,
                    keyTitle: this.$t('table.header.created_on'),
                    keyType: 'Default',
                    class: [],
                    keyRange: [],
                    values: this.moment().locale(this.$t('country')).format('lll')
                }, {
                    index: 2,
                    keyTitle: this.$t('details'),
                    keyType: 'textArea',
                    class: ['note_layout'],
                    parentClass: ['columns_2', 'flex-col', 'note_layout_parent'],
                    keyRange: [],
                    values: '',
                    maxLength: 4095,
                }];
            return {
                noteTitle: '',
                today: this.moment().locale(this.$t('country')).format('lll'),
                noteContent: '',
                items: item
            }
        },
        methods: {

            goBack() {
                if (this.selectedIdx !== undefined) {
                    this.$emit(`changeNoteComponent`, 2, this.selectedIdx);
                } else {
                    this.$emit(`changeNoteComponent`, 0);
                }
            },
            initValue() {
                this.items[0].values = '';
                this.items[1].values = this.moment().locale(this.$t('country')).format('lll');
                this.items[2].values = '';
            },
            setValue() {
                this.items[0].values = this.notes[this.selectedIdx].noteTitle;
                this.items[1].values = this.moment(this.notes[this.selectedIdx].createDatetime).locale(this.$t('country')).format('lll');
                this.items[2].values = this.notes[this.selectedIdx].noteContent;
            },
            getValue() {
                let noteData = {};
                if (typeof this.selectedIdx === "number") {
                    noteData.seqManagerNote = this.notes[this.selectedIdx].seqManagerNote;
                    noteData.seqMedicalRelation = this.seqMedicalRelation;
                    noteData.noteTitle = this.items[0].values;
                    noteData.noteContent = this.items[2].values;
                    noteData.isPublic = 1;
                    noteData.isImportant =  this.notes[this.selectedIdx].isImportant;
                } else {
                    noteData.seqMedicalRelation = this.seqMedicalRelation;
                    noteData.noteTitle = this.items[0].values;
                    noteData.noteContent = this.items[2].values;
                    noteData.isPublic = 1;
                    noteData.isImportant = 0; //추후 이곳을 수정함으로써 기능을 확장할수있을것.(작성시 중요체크)
                }
                return noteData;
            }
        },
        mounted() {
            if (typeof this.selectedIdx === "number") {
                this.setValue();
            }
        },
        watch: {
            selectedIdx() {
                if (typeof this.selectedIdx === "number") {
                    this.setValue();
                } else {
                    this.initValue();
                }
            }
        }
    }
</script>

<style lang="scss">
.NoteWrite {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  height: 100%;

  flex: 9 9 10rem;
  overflow: hidden;

  .table-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 50px;
    width: 100%;
    overflow: hidden;
    flex: 1 1 1rem;

    .note_view_scroll {
      overflow: scroll;
    }

    .item-parent {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0.5rem;
      text-align: left;

      &.columns_2 {
        grid-column: 1/3;
      }

      &.row_2 {
        grid-row: 1/3;
      }

      .item-title {
        flex: 1 1 1rem;

        font-weight: bold;
      }

      .item-value {
        flex: 8 3 1rem;
        margin-right: 50px;
      }

      &.flex-col {
        flex-direction: column;
        align-items: flex-start;
        overflow: hidden;

        .item-title {
          margin-bottom: 1rem;
          flex: 0 0 0;
        }

        .item-value {
          /*margin-bottom: 1rem;*/
          white-space: pre-line;
          overflow: hidden;
        }
      }

      &:nth-child(2) {
        .item-title {
          flex: 1 1 1rem;
        }

        .item-value {
          flex: 3 3 1rem;
        }
      }
    }
  }

  .bottom_btn_2 {
    margin-bottom: 1.5rem;
  }
}
</style>